
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $5DwXE = parcelRequire("5DwXE");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $dpRHA = parcelRequire("dpRHA");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $haRZ2 = parcelRequire("haRZ2");

var $2o3CH = parcelRequire("2o3CH");

var $bV0pP = parcelRequire("bV0pP");
/* global $ */ const $4be2ff30c993fc81$var$source = new (0, $9jDAx.default)();
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $4be2ff30c993fc81$var$ol2d = new (0, $5DwXE.default)({
    layers: [
        new (0, $4mWlF.default)({
            source: $4be2ff30c993fc81$var$source
        })
    ],
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    target: "map",
    view: new (0, $9DiKA.default)({
        center: (0, $dpRHA.transform)([
            -112.2,
            36.06
        ], "EPSG:4326", "EPSG:3857"),
        zoom: 11
    })
});
const $4be2ff30c993fc81$var$ol3d = new (0, $cc3xD.default)({
    map: $4be2ff30c993fc81$var$ol2d,
    target: "map3d"
});
const $4be2ff30c993fc81$var$scene = $4be2ff30c993fc81$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$4be2ff30c993fc81$var$scene.terrainProvider = tp);
class $4be2ff30c993fc81$var$OverlayHandler {
    constructor(ol2d, ol3d, scene){
        this.ol2d = ol2d;
        this.ol3d = ol3d;
        this.scene = scene;
        this.staticOverlay = new (0, $haRZ2.default)({
            element: document.getElementById("popup")
        });
        this.staticBootstrapPopup = new (0, $haRZ2.default)({
            element: document.getElementById("popup-bootstrap")
        });
        this.ol2d.addOverlay(this.staticOverlay);
        this.ol2d.addOverlay(this.staticBootstrapPopup);
        this.options = {
            boostrap: false,
            add: true
        };
        this.ol2d.on("click", this.onClickHandlerOL.bind(this));
        const eventHandler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
        eventHandler.setInputAction(this.onClickHandlerCS.bind(this), Cesium.ScreenSpaceEventType["LEFT_CLICK"]);
        const clickForm = document.getElementById("click-action-form");
        clickForm.onchange = (function(event) {
            const checked = $('input[name="click-action"]:checked').val();
            this.options.add = checked === "add";
        }).bind(this);
        const typeForm = document.getElementById("overlay-type-form");
        typeForm.onchange = (function(event) {
            const checked = $('input[name="overlay-type"]:checked').val();
            this.options.boostrap = checked === "popover";
        }).bind(this);
    }
    onClickHandlerOL(event) {
        const coordinates = event.coordinate;
        const hdms = (0, $2o3CH.toStringHDMS)((0, $dpRHA.transform)(coordinates, "EPSG:3857", "EPSG:4326"));
        const overlay = this.getOverlay();
        overlay.setPosition(coordinates);
        this.setOverlayContent(overlay, hdms);
    }
    onClickHandlerCS(event) {
        if (event.position.x === 0 && event.position.y === 0) return;
        const ray = this.scene.camera.getPickRay(event.position);
        const cartesian = this.scene.globe.pick(ray, $4be2ff30c993fc81$var$scene);
        if (!cartesian) return;
        const cartographic = $4be2ff30c993fc81$var$scene.globe.ellipsoid.cartesianToCartographic(cartesian);
        let coords = [
            Cesium.Math.toDegrees(cartographic.longitude),
            Cesium.Math.toDegrees(cartographic.latitude)
        ];
        const height = $4be2ff30c993fc81$var$scene.globe.getHeight(cartographic);
        if (height) coords = coords.concat([
            height
        ]);
        const transformedCoords = (0, $dpRHA.transform)(coords, (0, $dpRHA.get)("EPSG:4326"), "EPSG:3857");
        const hdms = (0, $2o3CH.toStringHDMS)(coords);
        const overlay = this.getOverlay();
        overlay.setPosition(transformedCoords);
        this.setOverlayContent(overlay, hdms);
    }
    getOverlay() {
        if (this.options.add) return this.addOverlay();
        if (this.options.boostrap) return this.staticBootstrapPopup;
        return this.staticOverlay;
    }
    setOverlayContent(overlay, hdms) {
        const element = overlay.getElement();
        if (this.options.boostrap) {
            const div = document.createElement("div");
            div.onclick = this.onCloseClick.bind(this, overlay, this.options.add);
            div.innerHTML = `<p>The location you clicked was:</p><code>${hdms}</code>`;
            $(element).popover("destroy");
            $(element).popover({
                "placement": "top",
                "animation": false,
                "html": true,
                "content": div
            });
            $(element).popover("show");
        } else element.childNodes.forEach((child)=>{
            if (child.id === "popup-content") child.innerHTML = `<p>The location you clicked was:</p><code>${hdms}</code>`;
            else if (child.id === "popup-closer") child.onclick = this.onCloseClick.bind(this, overlay, this.options.add);
        });
    }
    onCloseClick(overlay, add) {
        if (add) this.ol2d.removeOverlay(overlay);
        else overlay.setPosition(undefined);
    }
    addOverlay() {
        let element;
        if (this.options.boostrap) element = document.getElementById("popup-bootstrap").cloneNode(true);
        else element = document.getElementById("popup").cloneNode(true);
        const overlay = new (0, $haRZ2.default)({
            element: element
        });
        this.ol2d.addOverlay(overlay);
        return overlay;
    }
}
new $4be2ff30c993fc81$var$OverlayHandler($4be2ff30c993fc81$var$ol2d, $4be2ff30c993fc81$var$ol3d, $4be2ff30c993fc81$var$scene);
document.getElementById("enable").addEventListener("click", ()=>$4be2ff30c993fc81$var$ol3d.setEnabled(!$4be2ff30c993fc81$var$ol3d.getEnabled()));


//# sourceMappingURL=overlay.2a75776a.js.map
